import React, { useCallback, useState } from "react";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import WorkflowForm from "./WorkflowForm";

function Workflow({ params }) {
  const [openDialog, setOpenDialog] = useState(false);

  const handleClose = useCallback(() => {
    setOpenDialog(false);
  }, []);

  const handleClick = useCallback(() => {
    setOpenDialog(true);
  }, []);

  return (
    <>
      {openDialog && (
        <FormDialog
          open={openDialog}
          handleClose={handleClose}
          title={"Change Workflow"}
          btnTitle={"Update"}
          className={"workflow-dialog"}
          fullWidth={true}>
          <WorkflowForm params={params} onClose={handleClose} />
        </FormDialog>
      )}
      <div onClick={handleClick} className="cursor-pointer">
        <p className="underline capitalize">{params?.value}</p>
      </div>
    </>
  );
}

const isChangeWorkflow = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.board_id === nextProps?.params?.row?.board_id
    && prevProps?.params?.value === nextProps?.params?.value
    && prevProps?.params?.row?.workflow_id === nextProps?.params?.row?.workflow_id
    && prevProps?.params?.row?.board_name === nextProps?.params?.row?.board_name
    && prevProps?.params?.row?.card_exists === nextProps?.params?.row?.card_exists
  );
};

export default React.memo(Workflow, isChangeWorkflow);
